import React, { useState, useEffect, useCallback } from 'react';
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { Table, Button, Avatar, Skeleton, Modal, Input, Select, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import UserImage from '../assets/usmon_logo.png';
import './UserPageStyle.scss';
import { apiCall } from '../api/apiRoutes.ts';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { NetworkInfo } from "../constants/network.ts";
import { useDispatch } from "react-redux";
import { useAuth } from "../components/AuthContext.tsx";
import showMessageQueue from '../utils/messageUtils.js';

export interface LicensesState {
  assignedLicenses: number;
  availableLicenses: number;
}
const { Option } = Select;
const ClientsCell = ({ clientDetails, clients }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const matchedClients = Array.isArray(clientDetails)
    ? clientDetails
      .map((detail: any) => {
        const matched: any = clients?.find(
          (c: any) => c.client_id === detail.client_id
        );
        return matched?.client_mother_company;
      })
      .filter(Boolean)
    : [];

  const firstThree = matchedClients.slice(0, 3);
  const remaining = matchedClients.length - 3;

  const displayText = firstThree.join(', ');

  return (
    <>
      <span>
        {displayText || '-'}
        {remaining > 0 && (
          <>
            {' '}
            <span onClick={() => setIsModalOpen(true)} style={{ color: '#1890ff', cursor: "pointer" }}>
              +{remaining} more
            </span>
          </>
        )}
      </span>

      <Modal
        title="All Clients"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        className="custom-modal"
        centered
      >
        <ul className="custom-modal-list">
          {matchedClients.map((client, index) => (
            <li key={index}>{client}</li>
          ))}
        </ul>
      </Modal>
    </>
  );
};

const Users: React.FC = () => {


  const columns = [
    {
      title: 'USER ID',
      dataIndex: 'userid',
      key: 'userid',
      width: '300px',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Avatar src={UserImage} alt={text} />
          {text ? text : 'N/A'}
        </div>
      ),
    },
    {
      title: 'CLIENTS',
      dataIndex: 'clientDetails',
      key: 'clientDetails',
      width: '500px',
      render: (clientDetails, record) => {
        return <ClientsCell clientDetails={clientDetails} clients={clients} />;
      },
      // render: (clientDetails, record) => {
      //   const filteredClients = selectedClient
      //     ? clientDetails.filter((c: any) => c.client_id === Number(selectedClient))
      //     : clientDetails;
      //   return <ClientsCell clientDetails={filteredClients} clients={clients} />;
      // },
    },
    {
      title: 'CATEGORY',
      dataIndex: 'catagory',
      key: 'catagory',
      render: (text, record) => {
        let categoryDisplay = '-';

        if (text) {
          if (text === 'Admin1' || text === 'Admin2') {
            categoryDisplay = 'Client Admin';
          } else if (text === 'User') {
            categoryDisplay = 'User';
          } else {
            categoryDisplay = 'User';
          }
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {categoryDisplay}
          </div>
        );
      },
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (record: any) => (
        <Tooltip
          title='Assign clients'
        >
          <Button icon={<PlusOutlined />} onClick={() => showEditModal(record)} />
        </Tooltip>
      ),
    }
  ];
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [records, setTotalRecords] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchState, setSearchState] = useState("");
  const [searchCall, setSearchCall] = useState(false);
  const [selectedClient, setSelectedClient] = useState<string>("");
  // edit license flow
  const [userData, setUserData] = useState({ email: '', assignedClientIds: [], category: null, regionId: '', webUserId: '' })
  const [messages, contextHolder] = message.useMessage();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [clients, setClients] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const categoryOptions = [{ label: 'Client Admin', value: 'Admin1' }, { label: 'User', value: 'user' }];
  const rowsPerPage = 10;
  const { user } = useAuth();
  const navigate = useNavigate();
  const isUsersPageAccessible = user?.isUserAdmin === 'usmon-admin' ? true : false

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isUsersPageAccessible === false) {
      navigate('/unauthorized-access');
    }
  }, [isUsersPageAccessible, navigate]);


  /**
   * Assigns the clients to users
   */
  const handleAssignClient = () => {    
    return new Promise((resolve, reject) => {
      const data = {
        web_user_id: userData?.webUserId,
        client_ids: userData?.assignedClientIds,
        region_id: 1,
        catagory: userData?.category || null
      }
      apiCall(data, `${NetworkInfo.endpoints.webclient}${NetworkInfo.endpoints.assignClient}`, "post", false, false, false).then((response: any) => {
        if (response?.success) {
          setIsEditModalOpen(false);
          setUserData((prev) => ({
            ...prev,
            assignedClientIds: []  
          }));
          fetchUsers()
          resolve(''); 
          showMessageQueue(messages, "success", "Clients assigned successfully")
        } else {
          setDataSource([]);
          showMessageQueue(messages, "error", response?.message)
          reject(new Error(response?.message)); 
        }
      })
        .catch((error) => {
          showMessageQueue(messages, "error", "Failed to assign clients")
          reject(error); // Reject the Promise if API call fails
        });
    })
  }
  const handleCategoryFilterChange = (value: string) => {
    setSelectedCategory(value === "all" ? null : value);
    setCurrentPage(1);
    setSearchCall(!searchCall);
  };

  /**
   * fetches the users data
   * @returns
   */
  const fetchUsers = useCallback(async (): Promise<void> => {
    return new Promise((resolve, reject) => {
      let params: any = { page: currentPage, size: rowsPerPage };
      if (searchState) {
        params = { ...params, userid: searchState };
      }
      if (selectedCategory) {
        params = { ...params, catagory: selectedCategory };
      }
      if (selectedClient) {
        params = { ...params, clientMotherCompany: selectedClient };
      }

      const queryString = new URLSearchParams(params as any).toString();
      setLoading(true);
      apiCall({}, `${NetworkInfo.endpoints.webclient}${NetworkInfo.endpoints.webuser}?${queryString}`, "get", true, false, false).then((response: any) => {
        if (response?.success) {
          setTotalRecords(response?.data?.pagination?.totalRecords);
          let data: any = response?.data?.users || []
          setDataSource(data);
          resolve();
          setLoading(false);
          if (searchState && response?.data?.users?.length === 0) {
            setCurrentPage(1)
          }
        } else {
          setDataSource([]);
          setTotalRecords(1);
          showMessageQueue(messages, "error", response?.message)
          reject(new Error(response?.message));
          setLoading(false);
        }
      })
        .catch((error) => {
          showMessageQueue(messages, "error", "Failed to fetch users licenses")
          setLoading(false)
          reject(error);
        });
    })
  }, [currentPage, messages, searchState, selectedCategory, selectedClient]);

  /**
 * fetches the users data
 * @returns
 */
  const fetchClients = useCallback(async (): Promise<void> => {
    return new Promise((resolve, reject) => {
      apiCall({}, `${NetworkInfo.endpoints.webclient}${NetworkInfo.endpoints.webclients}`, "get", true, false, false).then((response: any) => {
        if (response?.success) {
          setClients(response?.data);
          resolve();
        } else {
          setDataSource([]);
          showMessageQueue(messages, "error", response?.message)
          reject(new Error(response?.message)); // Reject the Promise on API failure
        }
      })
        .catch((error) => {
          showMessageQueue(messages, "error", "Failed to fetch clients")
          reject(error); // Reject the Promise if API call fails
        });
    })
  }, [messages]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchUsers();
        await fetchClients();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch, currentPage, rowsPerPage, searchCall, fetchUsers, fetchClients]);

  const showEditModal = (record: any) => {
    setIsEditModalOpen(true);
    if (record) {
      setUserData((prev: any) => ({
        ...prev,
        assignedClientIds: record?.clientDetails?.length > 0 ? record?.clientDetails.map((client) => client?.client_id) : [],
        email: record?.userid,
        webUserId: record?.web_user_id,
        category: record?.catagory
      }))
    }
  };

  const handleEditOk = () => {
    setIsEditModalOpen(false);
  };

  /**
   * If clicked on cancel button assign or remove licenses modal
   */
  const handleEditCancel = () => {
    setIsEditModalOpen(false);
    setUserData({ email: '', assignedClientIds: [], category: null, regionId: '', webUserId: '' })
  };

  /**
   * pagination change event
   */
  const handleTableChange = useCallback((pagination) => {
    setCurrentPage(pagination.current);
    setSearchCall(!searchCall);
  }, [searchCall]);

  /**
   * stores the values in state
   * @param e
   */
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchState(e?.target?.value);
    if (e?.target?.value === '') {
      setSearchCall(!searchCall)
    }
  };

  /**
   * user list API will be called if clicked on seach icon
   */
  const handleSearchChangeApiCall = () => {
    setCurrentPage(1);
    setSearchCall(!searchCall)
  }

  return (
    <div className='main-wrapper'>
      {contextHolder}
      <div className="license-container">
        <div className='container'>
          <h2 className="license-title">Users Management</h2>
          <div className="license-filters">
            <div className="filters-right d-flex flex-wrap gap-3 align-items-end">
              {/* SEARCH BY USER EMAIL */}
              <div className="input-wrap search-input flex-grow-1">
                <label className="label-text">SEARCH BY USER EMAIL</label>
                <InputGroup>
                  <FloatingLabel controlId="floatingInput" label="User email" className="flex-grow-1">
                    <Form.Control
                      type="search"
                      placeholder="User email"
                      value={searchState}
                      onChange={handleSearchChange}
                    />
                  </FloatingLabel>
                  <InputGroup.Text onClick={handleSearchChangeApiCall} style={{ cursor: "pointer" }}>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </div>

              {/* FILTER BY CATEGORY */}
              <div className="input-wrap category-filter" style={{ minWidth: "200px" }}>
                <label className="label-text">FILTER BY CATEGORY</label>
                <FloatingLabel controlId="floatingSelect" label="User type">
                  <Form.Select
                    aria-label="User type"
                    value={selectedCategory || "all"}
                    onChange={(e) => handleCategoryFilterChange(e.target.value)}
                  >
                    <option value="all">All</option>
                    <option value="user">User</option>
                    <option value="Admin">Client Admin</option>
                    <option value="noCatagory">No Category</option>
                  </Form.Select>
                </FloatingLabel>
              </div>

              {/* FILTER BY CLIENT */}
              <div className="input-wrap category-filter flex-grow-1" style={{ minWidth: "250px" }}>
                <label className="label-text">FILTER BY CLIENT</label>
                <Select
                  placeholder="Select clients"
                  value={userData.assignedClientIds || []}
                  onChange={(selectedValues: any) => {
                    const values = selectedValues || '';
                    setUserData((prev: any) => ({
                      ...prev,
                      assignedClientIds: values,
                    }));
                    setSelectedClient(values);
                    setCurrentPage(1);
                    // if (values === 0) {
                    //   setCurrentPage(1);
                    // }
                  }}
                  style={{ height: "48px" }}
                  allowClear
                  showSearch
                  filterOption={(input: string, option: any) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  className="mt-0"
                >
                  {clients.map((option: any) => (
                    <Select.Option
                      key={`${option.client_id}-${option.client_mother_company}-${option.region_short_name}`}
                      value={option.client_id}
                    >
                      {option.client_mother_company}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          {loading ?
            (
              Array.from({ length: rowsPerPage }).map((_, index) => (
                <Skeleton key={index} active avatar paragraph={{ rows: 2 }} />
              ))
            ) :
            <Table
              dataSource={dataSource || []}
              columns={columns || []}
              className="license-table"
              pagination={
                {
                  pageSize: rowsPerPage,
                  total: records,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // Custom text
                  current: currentPage,
                  showSizeChanger: false
                }
              }
              scroll={screenWidth < 1200 ? { x: 1100 } : undefined}
              tableLayout="auto"
              onChange={handleTableChange}
            />
          }
        </div>
      </div>

      <Modal className='Request-modal' title="Assign or Remove Client" open={isEditModalOpen} onOk={handleEditOk} onCancel={handleEditCancel} centered>
        <div className="input-wrap">
          <label className="label-text">SELECTED USER</label>
          <p className='mb-0'>Clients can be assigned or removed at a time.</p>
          <div className={`antd-floating-label-select focused"`}>
            <Input value={userData?.email} disabled />

            <label className="label-text mt-3">SELECT CLIENTS</label>

            <Select
              mode="multiple"
              placeholder="Select clients"
              value={userData.assignedClientIds}
              onChange={(selectedValues: string[]) => {
                setUserData((prev: any) => ({
                  ...prev,
                  assignedClientIds: selectedValues,
                }));
              }}
              allowClear
              showSearch
              filterOption={(input: string, option: any) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              className="mt-3"
              maxTagCount="responsive"  
            >
              {clients.map((option: any) => (
                <Option
                  key={`${option.client_id}-${option.client_mother_company}-${option.region_short_name}`}
                  value={option.client_id}
                >
                  {option.client_mother_company}
                </Option>
              ))}
            </Select>

            <label className="label-text mt-5">SELECT CATEGORY</label>

            <Select
              placeholder="Select user"
              value={userData?.category}
              onChange={(cat: string) => {
                setUserData((prev: any) => ({
                  ...prev,
                  category: cat,
                }));
              }}
              allowClear
              className="mt-2"
            >
              {categoryOptions.map((option: any) => (
                <Option
                  key={`${option.value}`}
                  value={option.value}
                >
                  {option.label}
                </Option>
              ))}
            </Select>
          </div>
        </div>


        <div className='modal-footer'>
          <button type="button" className="primary-btn blank" onClick={handleEditCancel}><span>Cancel</span></button>
          <button type="button"
            className="primary-btn"
            disabled={userData?.assignedClientIds.length === 0 || userData?.category === null}
            onClick={handleAssignClient}>
            <span>Assign</span>
          </button>
        </div>
      </Modal>
    </div>

  );
};

export default Users;